module.exports = __webpack_public_path__ + "img/logo.4419cf0b.svg";